import { TFunction } from 'i18next';
import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { FormStepFailure } from './formStepRegistry';
import { appendFinalValidationSearchParam } from './finalValidationNavigation';

export function buildFormStepFailuresContent(failures: FormStepFailure[], t: TFunction): ReactNode {
  return (
    <ul>
      {failures.map((failure) => (
        <li key={failure.stepId}>
          <NavLink to={appendFinalValidationSearchParam(`../${failure.routeSegment}`)}>{t(failure.labelKey)}</NavLink>
        </li>
      ))}
    </ul>
  );
}
